// extracted by mini-css-extract-plugin
export default {"header":"Header_header__ylZ7y","greeting":"Header_greeting__2dz7G","links":"Header_links__Dpwj1"};